import React from "react";
import { ShieldCheck } from "lucide-react";
import NarrativeAssessmentCardBase from "./NarrativeAssessmentCardBase";

const GoogleMerchantCenterNarrativeAssessmentViewer = ({ markdown = "" }) => (
  <NarrativeAssessmentCardBase
    markdown={markdown}
    Icon={ShieldCheck}
    subtitle="Trust readiness, policy risk, and buyer confidence"
    badge="MERCHANT"
    theme={{
      cardBg: "#eefcf4",
      cardBorder: "#b7efcf",
      heroBg: "#d8f8e8",
      heroBorder: "#9de6c0",
      badgeBg: "rgba(34, 197, 94, 0.12)",
      badgeBorder: "#16a34a",
      iconColor: "#15803d",
      dotColor: "#16a34a",
    }}
  />
);

export default GoogleMerchantCenterNarrativeAssessmentViewer;
